/**
 * One panel per signer of a signing slot, carrying the `(role, ordinal,
 * signerIndex)` identity e-signing placement measures by. Without a roster
 * it is one unnamed panel — the legacy lane's draft/preview look, where
 * the namnförtydligande is a blank line.
 */
export function signerPanels(input) {
    const ordinal = input.ordinal ?? 0;
    const base = {
        label: input.label,
        role: input.role,
        ordinal,
        ...(input.party?.id ? { partyRef: input.party.id } : {}),
        showPlaceDate: input.showPlaceDate ?? true,
    };
    const signers = input.party?.signatories ?? [];
    if (signers.length === 0) {
        return [{ ...base, name: null, signerIndex: 0, signerCount: 1, anchor: `sig:${input.role}:${ordinal}:0` }];
    }
    return signers.map((signer, index) => ({
        ...base,
        name: signer.name ?? null,
        entity: input.party?.kind === 'organisation' ? input.party.name : null,
        capacity: signer.capacity ?? null,
        legalId: signer.legalId ?? null,
        signerIndex: index,
        signerCount: signers.length,
        anchor: `sig:${input.role}:${ordinal}:${index}`,
    }));
}
//# sourceMappingURL=signing.js.map